export default "__VITE_ASSET__ceb42eb3__"